import React from 'react';
import { Container } from '../Container';
import { Reveal } from '../Reveal';
import { ButtonLink } from '../ButtonLink';
import { AppImage } from '../AppImage';
import { servicesHeroImage } from '../../data/servicesImages';
export function ServicesHero() {
  return <section className="border-b border-hairline bg-canvas pb-section-sm pt-[104px] lg:pb-section lg:pt-[156px]" data-id="element-874" data-mp="37y8esxc9op8o">
      <Container data-id="element-875" data-mp="3hubgy374cnvm">
        <Reveal data-id="element-876" data-mp="3huv01n8i9ib8">
          <p className="text-small text-muted" data-id="element-877" data-mp="3hta5hxm6xzdd">Services / 05 pillars</p>
          <div className="mt-5 grid items-center gap-10 lg:grid-cols-12 lg:gap-12" data-id="element-878" data-mp="3lv542ucqlyng">
            <h1 className="max-w-[15ch] font-serif text-[clamp(48px,6vw,88px)] font-normal leading-[1.05] tracking-[-0.03em] text-ink lg:col-span-7" data-id="element-879" data-mp="3qmdik4sxca7h">
              Design support for every stage of becoming harder to ignore.
            </h1>
            <AppImage src={servicesHeroImage.image} alt={servicesHeroImage.alt} ratio="16:10" className="lg:col-span-5" data-id="element-880" data-mp="4gghd3fd3d33" />
          </div>
          <div className="mt-10 grid gap-8 border-t border-hairline pt-6 lg:grid-cols-12 lg:gap-10" data-id="element-881" data-mp="2az5j9gfn1bw4">
            <div className="lg:col-span-7" data-id="element-882" data-mp="25xogtghi9hdf">
              <p className="max-w-[52ch] text-body text-muted" data-id="element-883" data-mp="2106j6m8xuokq">
                We shape brands, websites and product experiences for ambitious companies. Start
                with one pillar, or bring us in for the connected system.
              </p>
              <p className="mt-5 max-w-[68ch] text-[15px] leading-6 text-[#6E6E6E]" data-id="element-884" data-mp="2toc2d4kcg5ig">
                Timelines shown are for that pillar run on its own. Most projects combine two or
                three pillars into a single schedule, so the total is shorter than adding these
                together. You get the full schedule on day one.
              </p>
            </div>
            <div className="flex items-start lg:col-span-3 lg:col-start-10 lg:justify-end" data-id="element-885" data-mp="3cflgjr527igd">
              <ButtonLink to="/contact" data-id="element-886" data-mp="37od22govh6wc">Start a project</ButtonLink>
            </div>
          </div>
        </Reveal>
      </Container>
    </section>;
}